import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessInputClass;
function GrantDiscordAccessInput() {
  if (GrantDiscordAccessInputClass === VOID) {
    class $ {
      constructor(code, partyId, guildId) {
        this.y71_1 = code;
        this.z71_1 = partyId;
        this.a72_1 = guildId;
      }
      toString() {
        return 'GrantDiscordAccessInput(code=' + this.y71_1 + ', partyId=' + this.z71_1.toString() + ', guildId=' + this.a72_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.y71_1);
        result = imul(result, 31) + this.z71_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.a72_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GrantDiscordAccessInput()))
          return false;
        if (!(this.y71_1 === other.y71_1))
          return false;
        if (!this.z71_1.equals(other.z71_1))
          return false;
        if (!(this.a72_1 === other.a72_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GrantDiscordAccessInput');
    GrantDiscordAccessInputClass = $;
  }
  return GrantDiscordAccessInputClass;
}
//region block: exports
export {
  GrantDiscordAccessInput as GrantDiscordAccessInputqu7hxtlblgwv,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessInput.mjs.map
